import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import ObjectObservable from "../utils/ObjectObservable" ;
import ResultStatus from "../classes/ResultStatus" ;
import LabelWithInputField from "./LabelWithInputField" ;
import SuccessMessage from "../classes/SuccessMessage" ;
import D3EDate from "../classes/D3EDate" ;
import EventBus from "../utils/EventBus" ;
import LabelWithDateField from "./LabelWithDateField" ;
import PageNavigator from "../classes/PageNavigator" ;
import Result from "../classes/Result" ;
import PopupWrapperView from "./PopupWrapperView" ;
import Button from "./Button" ;
import ListWrapper from "../utils/ListWrapper" ;
import LeadRemainder from "../models/LeadRemainder" ;
import TextView from "./TextView" ;
import CollectionUtils from "../utils/CollectionUtils" ;
import { BuildContext } from "../classes/BuildContext" ;

type _CancelButtonOnPressed = ( d3eState : RemainderCreatorViewRefs ) => void ;

type _UserButtonOnPressed = ( d3eState : RemainderCreatorViewRefs ) => void ;

type _LabelWithInputFieldOnChanged = ( text : string,d3eState : RemainderCreatorViewRefs ) => void ;

type _LabelWithDateField5OnChanged = ( text : D3EDate,d3eState : RemainderCreatorViewRefs ) => void ;

type _LabelWithInputFieldExtOnChanged = ( text : string,d3eState : RemainderCreatorViewRefs ) => void ;


  export  interface  RemainderCreatorViewProps extends  BaseUIProps {   key?: string ;
   leadRemainder: LeadRemainder ;
 }
/// To store state data for RemainderCreatorView 
   class  RemainderCreatorViewRefs {  public cancelButton: CancelButtonState = new CancelButtonState() ;
  public userButton: UserButtonState = new UserButtonState() ;
 }

   interface  UserButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: RemainderCreatorViewRefs ;
   _onAddUserHandler?: _UserButtonOnPressed ;
 }

   class  UserButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public _hover: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _UserButtonWithState extends  ObservableComponent<UserButtonWithStateProps> {   userButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : UserButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get userButton (  ) : UserButtonState {
 return this.props.d3eState.userButton ; 
 }
  public get d3eState (  ) : RemainderCreatorViewRefs {
 return this.props.d3eState ; 
 }
  public get _onAddUserHandler (  ) : _UserButtonOnPressed {
 return this.props._onAddUserHandler ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('userButton',null,this.userButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'userButton', 'userButton.hover' ],this.rebuild);
 }
  public userButtonOnEnter ( event ) : void {
 return this.userButton.setHover(true) ; 
 }
  public userButtonOnExit ( event ) : void {
 return this.userButton.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.userButton.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ child:Button({ padding:cStyle.tButtonPrimaryPaddingOn, decoration:cStyle.tButtonPrimaryDecorationOn, disable:this.userButton.disable, onPressed:(  ) => {
 this._onAddUserHandler(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:TextView({ data:'Save ' }), onEnter:( event ) => {
 this.userButtonOnEnter(event);
 }
, onExit:( event ) => {
 this.userButtonOnExit(event);
 }
 }), className:'Primary x7d3' }) ; 
 }
 }
function UserButtonWithState ( props : UserButtonWithStateProps ) {
 return React.createElement(_UserButtonWithState,props) ; 
 }


   interface  CancelButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: RemainderCreatorViewRefs ;
   _cancelButtonHandler?: _CancelButtonOnPressed ;
 }

   class  CancelButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public _hover: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _CancelButtonWithState extends  ObservableComponent<CancelButtonWithStateProps> {   cancelButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : CancelButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get cancelButton (  ) : CancelButtonState {
 return this.props.d3eState.cancelButton ; 
 }
  public get d3eState (  ) : RemainderCreatorViewRefs {
 return this.props.d3eState ; 
 }
  public get _cancelButtonHandler (  ) : _CancelButtonOnPressed {
 return this.props._cancelButtonHandler ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('cancelButton',null,this.cancelButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'cancelButton', 'cancelButton.hover' ],this.rebuild);
 }
  public cancelButtonOnEnter ( event ) : void {
 return this.cancelButton.setHover(true) ; 
 }
  public cancelButtonOnExit ( event ) : void {
 return this.cancelButton.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.cancelButton.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ child:Button({ padding:cStyle.tButtonSecondaryPaddingOn, decoration:cStyle.tButtonSecondaryDecorationOn, disable:this.cancelButton.disable, onPressed:(  ) => {
 this._cancelButtonHandler(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:TextView({ data:'Cancel' }), onEnter:( event ) => {
 this.cancelButtonOnEnter(event);
 }
, onExit:( event ) => {
 this.cancelButtonOnExit(event);
 }
 }), className:'Secondary xb5d' }) ; 
 }
 }
function CancelButtonWithState ( props : CancelButtonWithStateProps ) {
 return React.createElement(_CancelButtonWithState,props) ; 
 }


   class  _RemainderCreatorViewState extends  ObservableComponent<RemainderCreatorViewProps> {   static defaultProps = { leadRemainder:null } ;
   d3eState: RemainderCreatorViewRefs = new RemainderCreatorViewRefs() ;
   errors: Array<string> = ListWrapper.widget(this,'errors') ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : RemainderCreatorViewProps ) {
 super(props);

this.initState();
 }
  public get leadRemainder (  ) : LeadRemainder {
 return this.props.leadRemainder ; 
 }
  public initState (  ) {
 super.initState();

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.updateSyncProperty('leadRemainder',this.props.leadRemainder);

this.on([ 'errors', 'leadRemainder', 'leadRemainder.description', 'leadRemainder.remainderDate', 'leadRemainder.title' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : RemainderCreatorViewProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.leadRemainder !== this.props.leadRemainder ) {
 this.updateObservable('leadRemainder',prevProps.leadRemainder,this.props.leadRemainder);

this.fire('leadRemainder',this);
 }
 }
  public setErrors ( val : Array<string> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.errors,val);

if ( !isValChanged ) {
 return ; 
 }

this.errors.clear();

this.errors.addAll(val);

this.fire('errors',this);
 }
  public addToErrors ( val : string,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.errors.contains(val) ) this.errors.add(val);
 }
 else {
 this.errors.remove(this.errors.elementAt(index));

this.errors.add(val);
 }

this.fire('errors',this,val,true);
 }
  public removeFromErrors ( val : string ) : void {
 this.errors.remove(val);

this.fire('errors',this,val,false);
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return PopupWrapperView({ title:'Add New Remainder', content:ui.Column({ children:[ LabelWithInputField({ name:'Name', placeHolder:'Enter Title', value:this.leadRemainder.title, isRequired:true, onChanged:( text ) => {
 this.labelWithInputFieldonChanged(text,this.d3eState);
 }
, className:'x657 hc h', key:'0' }), LabelWithDateField({ name:'Remainder Date', placeHolder:'Select Remainder Date', value:this.leadRemainder.remainderDate, onChanged:( text ) => {
 this.labelWithDateField5onChanged(text,this.d3eState);
 }
, className:'x202 hc h', key:'1' }), LabelWithInputField({ name:'Description', placeHolder:'Enter Description', value:this.leadRemainder.description, onChanged:( text ) => {
 this.labelWithInputFieldExtonChanged(text,this.d3eState);
 }
, className:'x246 hc h', key:'2' }), (this.errors).expand(( error ) => [ ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ TextView({ data:error, textAlign:cStyle.tTextViewErrorTextTextAlignOn, style:new ui.TextStyle({color:cStyle.tTextViewErrorTextColorOn}), className:'ErrorText x0ae hc', key:'0' }) ], className:'xab3 hc', key:error?.toString() }) ]) ], className:'xa005 hc h' }), buttons:[ CancelButtonWithState({ d3eState:this.d3eState, _cancelButtonHandler:this.cancelButtonHandler, key:'0' }), UserButtonWithState({ d3eState:this.d3eState, _onAddUserHandler:this.onAddUserHandler, key:'1' }) ], className:ui.join('RemainderCreatorView hc vc ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }) ; 
 }
  public cancelButtonHandler  =  ( d3eState : RemainderCreatorViewRefs ) : void  =>  {
 this.leadRemainder.restore();

this.navigator.close();
 }
  public onAddUserHandler  =  async  ( d3eState : RemainderCreatorViewRefs ) : Promise<void>  =>  {
 let result :Result<LeadRemainder>=( await this.leadRemainder.save());

if ( result.status === ResultStatus.Success ) {
 EventBus.get().fire(new SuccessMessage({ message:'Successfully Saved' }));

this.navigator.close();
 }
 else {
 this.setErrors(result.errors);
 }
 }
  public labelWithInputFieldonChanged  =  ( val : string,d3eState : RemainderCreatorViewRefs ) : void  =>  {
 this.leadRemainder.setTitle(val);
 }
  public labelWithDateField5onChanged  =  ( val : D3EDate,d3eState : RemainderCreatorViewRefs ) : void  =>  {
 this.leadRemainder.setRemainderDate(val);
 }
  public labelWithInputFieldExtonChanged  =  ( val : string,d3eState : RemainderCreatorViewRefs ) : void  =>  {
 this.leadRemainder.setDescription(val);
 }
  public get navigator (  ) : PageNavigator {
 return PageNavigator.of(this.context) ; 
 }
  public get cancelButton (  ) {
 return this.d3eState.cancelButton ; 
 }
  public get userButton (  ) {
 return this.d3eState.userButton ; 
 }
 }
export default function RemainderCreatorView ( props : RemainderCreatorViewProps ) {
 return React.createElement(_RemainderCreatorViewState,{ ..._RemainderCreatorViewState.defaultProps, ...props }) ; 
 }
